import {getUploadingAttachments} from './attachmentUpload-selectors';
import {createSelector} from 'reselect';

export const getIsLoadingAttachments = state => state.attachments.isLoading;
export const getAttachmentsList = state => state.attachments.list;
export const getAttachmentsIssueId = state => state.attachments.issueId;
export const getCurrentlyViewedAttachments = state => state.gallery.attachments;
export const getHasMoreAttachments = state => state.attachments.list.length < state.attachments.totalResults;
export const getUploadingAndExistingAttachments = createSelector(
  getUploadingAttachments,
  getAttachmentsList,
  (uploadingAttachments, attachmentsList) => [...uploadingAttachments, ...attachmentsList]
);
